import { createTranslations } from '@npco/utils-translations'

export const businessRowTranslations = createTranslations({
  admin: 'Admin',
  manager: 'Manager',
  removeBusiness: 'Remove Business',
  businessListLabel: 'business list',
})
